<template>
  <div
    @click.stop="onClick"
    class="button-style"
    :class="{ disabled: disabled }"
  >
    {{ $t(buttonName) }}
  </div>
</template>

<script>
export default {
  name: "ProcessesButton",
  props: ["buttonName", "disabled"],
  methods: {
    onClick() {
      this.$emit("onClick");
    }
  }
};
</script>

<style scoped>
.button-style {
  min-width: 80px;
  margin: 15px 15px 0 0;
  padding: 5px 15px;
  border-radius: 2px;
  align-self: flex-end;
  background-color: var(--primary-highlight);
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
}
.disabled {
  color: var(--secondary-darker);
  background-color: #dcdcdd;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/Calculations/ProcessesButton.vue